import { getCurrentUser as getCurrentUser$1 } from '../cognito/cognito.helper.js';
import useAuthStore from '../auth.store.js';

/**
 * Get current user from Zustand store or fetch from Cognito if needed
 * This is the main entry point for user data - consumers should use this instead of calling Cognito directly
 * @param forceRefresh - If true, bypasses cache and fetches fresh data from Cognito
 */ const getCurrentUser = async (forceRefresh = false)=>{
    const store = useAuthStore.getState();
    if (!forceRefresh && store.user) {
        return store.user;
    }
    try {
        useAuthStore.getState().setUserLoading(true);
        useAuthStore.getState().setUserError(null);
        const user = await getCurrentUser$1(forceRefresh);
        useAuthStore.getState().setUser(user);
        return user;
    } catch (error) {
        useAuthStore.getState().setUserError(error);
        return null;
    } finally{
        useAuthStore.getState().setUserLoading(false);
    }
};
/**
 * Clear user data from store (useful on logout)
 */ const clearCurrentUser = ()=>{
    useAuthStore.getState().clearUser();
};
/**
 * Get user data from store without making API calls
 * Returns cached data if available, null otherwise
 */ const getCurrentUserFromStore = ()=>{
    return useAuthStore.getState().user;
};
/**
 * Check if user data is currently being loaded
 */ const isUserLoading = ()=>{
    return useAuthStore.getState().userLoading;
};
/**
 * Get any error that occurred while fetching user data
 */ const getUserError = ()=>{
    return useAuthStore.getState().userError;
};

export { clearCurrentUser, getCurrentUser, getCurrentUserFromStore, getUserError, isUserLoading };
//# sourceMappingURL=user.service.js.map
